import { Injectable } from '@angular/core';
import { ImportLinesheet } from '../../models/linesheet';
import { CartService } from '../cart/cart.service';

@Injectable({
  providedIn: 'root'
})
export class LinesheetImportSupportService {
  constructor(protected cartService: CartService) {}

  /**
   * The upload formats offered on the import page, in the order they are shown.
   * Overridable per customer to restrict what a given set of roles may pick —
   * the component filters its format cards on the returned list.
   */
  getAvailableUploadFormats(roles: string[]): string[] {
    return ['MATRIX_FORMAT', 'COLUMN_FORMAT', 'MULTI_ORDER_COLUMN_FORMAT'];
  }

  loadProductsToCart(
    uploadFormat: string,
    managedMultistockIds: string[],
    result: ImportLinesheet,
    replaceMode: string
  ) {
    for (const product of result.rows) {
      if (!!product && product.productId.includes('_GUNGDOT_')) {
        product.productId = product.productId.replace('_GUNGDOT_', '.');
      }
    }
    console.log('LinesheetImportSupportService', uploadFormat);
    if (
      uploadFormat === 'COLUMN_FORMAT' ||
      (uploadFormat === 'MATRIX_FORMAT' && replaceMode === 'REPLACE_CURRENT_ORDER')
    ) {
      this.cartService.clearCart();
    }

    const targetStockId = managedMultistockIds[0] || '*';
    const rows = result.rows.map(row => {
      return {
        productId: row.productId,
        qty: row.quantity,
        targetStockId
      };
    });

    this.cartService.bulkAddToCart(rows);
  }
}
